import { createRoomInviteCloud } from '../services/roomInviteService'

export type JoinLinkRoom = {
  id: string
  customRoomId?: string
  companyId?: string | null
  metadata?: { companyId?: string | null }
}

/** Copies a 24h same-company join link for the room to the clipboard. */
export async function copyRoomJoinLink(room: JoinLinkRoom, fallbackCompanyId: string | null): Promise<void> {
  const res = await createRoomInviteCloud({
    roomId: room.id,
    customRoomId: room.customRoomId ?? null,
    companyId: room.companyId ?? room.metadata?.companyId ?? fallbackCompanyId ?? null,
    linkPreset: '24h',
    audience: 'same_company',
    defaultJoinNear: true,
  })
  const fullUrl = `${typeof window !== 'undefined' ? window.location.origin : ''}${res.joinPath}`
  await navigator.clipboard.writeText(fullUrl)
}
